/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable react/no-is-mounted */
import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import io from 'socket.io-client';
import get from 'lodash/get';
import { CLOSE_USPS_MODEL, SET_ACTION_MESSAGE } from '../redux/types';
import { getParams } from '../util';
import host from '../util/host';
import router from '../util/router';
import SessionStorageServices from '../util/sessionStorageServices';
import { history } from '../redux/configureStore';
// import { getUserAbandonedData } from '../utils';

const getRole = () => {
  let role = getParams('role');
  if (!role) {
    const searchParams = new URLSearchParams(
      SessionStorageServices.getLocalValue('redirectAppPath'),
    );
    role = searchParams.get('role');
  }
  return role || '';
};

dayjs.extend(utc);
dayjs.extend(timezone);

export const currentSocket = null;
class HealthCheck extends React.PureComponent {
  constructor(props) {
    super(props);
    this.healthCheckInitiated = false;
    this.uid = '';
    this.lastInteractedQuestion = {};
    this.lastSectionSubmittedAt = '';
    this.excludePages = ['timeout', 'authcode', 'completed'];
    this._connectSocket = this._connectSocket.bind(this);
  }

  componentDidMount() {
    const uid = getParams('uid');

    if (uid) {
      this.uid = uid;
      if (this._shouldStartSocketConnection()) {
        this._connectSocket.call(this);
        this.healthCheckInitiated = true;
        console.log('HEALTH CHECK::: Initiating Health Check in Component Did Mount.');
        console.log('HEALTH CHECK::: UID: ', this.uid);
      }
    }

    const route = window.location.pathname.split('/')[1];
    if (route === 'view-document') {
      this.socket.emit('PING_ROUTE_CHANGE', {
        uid: this.uid,
        role: getRole(),
        route,
      });
    }

    this.unlisten = history.listen((_location) => {
      const { pathname } = _location;
      if (this.socket) {
        this.socket.emit('PING_ROUTE_CHANGE', {
          uid: this.uid,
          role: getRole(),
          route: pathname.slice(1),
        });
      }
    });
  }

  componentDidUpdate(prevProps) {
    const uid = getParams('uid');

    this.lastInteractedQuestion = prevProps?.lastInteractedQuestion;
    if (!this.healthCheckInitiated && uid) {
      this.uid = uid;
      if (this._shouldStartSocketConnection()) {
        this._connectSocket.call(this);
        this.healthCheckInitiated = true;
        console.log('HEALTH CHECK::: Initiating Health Check in Component Did Update.');
        console.log('HEALTH CHECK::: UID: ', this.uid);
      }
    }

    if (this.lastInteractedQuestion && this.lastInteractedQuestion.question_id) {
      console.log('found new last interacted question: ');
      if (this.socket) {
        this.socket.emit(
          'LAST_INTERACTED_QUESTION',
          JSON.stringify({
            uid: this.uid,
            question: this.lastInteractedQuestion,
          }),
        );
      }
    }
    if (this.lastSectionSubmittedAt !== prevProps.lastSectionSubmittedAt) {
      console.log('section submitted clearing questions');
      if (this.socket) {
        this.socket.emit(
          'CLEAR_LAST_INTERACTED_QUESTIONS',
          JSON.stringify({
            uid: this.uid,
          }),
        );
      }
      this.lastSectionSubmittedAt = prevProps.lastSectionSubmittedAt;
    }

    this.unlisten = history.listen((_location) => {
      const { pathname } = _location;
      if (this.socket) {
        this.socket.emit('PING_ROUTE_CHANGE', {
          uid: this.uid,
          role: getRole(),
          route: pathname.slice(1),
        });
      }
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  _shouldStartSocketConnection() {
    const currentPath = window.location.pathname.replace('/', '');
    if (currentPath === '') {
      return true;
    }
    return !this.excludePages.filter((pagePath) => pagePath.match(currentPath)).length;
  }

  // eslint-disable-next-line class-methods-use-this
  _getUserData() {
    return {
      userAgent: navigator.userAgent,
      sourcePage: window.location.pathname,
      sourceUrl: window.location.search,
      userTimeZone: dayjs(),
      currentDateTime: dayjs.tz.guess(),
      feature: 'health',
    };
  }

  _connectSocket() {
    console.log('Current Socket available before creating new socket connection?');
    const role = getRole();
    console.log(`HEALTH CHECK::: role for UID is ${role}`);
    const { WS_BASE_URL } = host();
    this.socket = io.connect(WS_BASE_URL, {
      transports: ['websocket'],
      upgrade: false,
      query: {
        ...this._getUserData(),
        uid: this.uid,
        role,
      },
      reconnection: true,
      reconnectionAttempts: 50,
      reconnectionDelayMax: 2000,
    });
    console.log('Connecting : ', WS_BASE_URL);

    this.socket.on('connect', () => {
      if (this.socket.socketRetry) {
        delete this.socket.socketRetry;
        this.socket.emit('START_HEALTH_CHECK', {
          ...this._getUserData(),
          uid: this.uid,
          serverRestart: true,
          role,
        });
      }
    });

    this.socket.emit('START_HEALTH_CHECK', {
      ...this._getUserData(),
      uid: this.uid,
      role,
    });
    // this.socket.on('PREPARE_ABANDON_DATA', () => {
    //   const questions = get(this.props, 'questions', []);
    //   console.log('HEALTH CHECK::: PREPARE_ABANDON_DATA: SOCKET Data received');
    //   const params = getUserAbandonedData(questions);
    //   console.log(params,'params');
    //   this.socket.emit('SEND_ABANDON_DATA', params);
    // });

    this.socket.on('reconnect', () => {
      const uid = getParams('uid');
      if (uid) {
        console.log('HEALTH CHECK::: Reconnecting : ', WS_BASE_URL);
      }
      this.socket.emit('START_HEALTH_CHECK', {
        ...this._getUserData(),
        uid,
        reconnect: true,
        role,
      });
    });
    this.socket.on('PING_EXPIRE_SESSION', (data) => {
      console.log(
        'HEALTH CHECK::: PING_EXPIRE_SESSION: SOCKET Data received',
        JSON.stringify(data),
      );
      const uid = getParams('uid');
      if (uid === data.uid) {
        const currentStatus = get(data, 'res.response.other_params.current_status', '');
        const { pathname } = window.location;
        if (pathname && currentStatus) {
          let searchParam = '';
          if (uid) {
            searchParam = `?uid=${uid}`;
          }
          this.socket.emit('PONG_EXPIRE_SESSION', {
            uid: this.uid,
            searchParam,
            ...this._getUserData(),
          });
          this.socket.disconnect(false);
          this.socket.removeAllListeners();
          const { handleTimeoutResponse } = this.props;
          handleTimeoutResponse({
            data: data.res,
          });
        }
      } else if (window.location.pathname === '/inactivesession') {
        this.socket.emit('PONG_EXPIRE_SESSION', {
          ...this._getUserData(),
        });
        this.socket.disconnect(false);
        this.socket.removeAllListeners();
      }
    });
    this.socket.on('RELOAD_WINDOW', (reason) => {
      console.log('RELOAD_WINDOW received for', reason.uid);
      if (reason.reload === true) {
        window.location.reload();
      }
    });
    this.socket.on('disconnect', (reason) => {
      console.log('HEALTH CHECK::: Socket Disconnected: ', reason);
      if (reason === 'transport close') {
        this.socket.socketRetry = true;
      }
    });
    console.log('Creating socket connection.');
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

const mapStateToProps = (state) => {
  // const socketQuestion = get(state, 'questions.socketQuestion', []);
  // const isReflexive = get(state, 'questions.isReflexiveQues', false);
  return {
    questions: state.questions,
    uid: state.uid,
    lastInteractedQuestion: state.questions.lastInteractedQuestion,
    lastSectionSubmittedAt: state.questions.lastSectionSubmittedAt,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    handleTimeoutResponse: (response) => {
      const uid = get(response, 'data.response.other_params.uid', '');
      const currentStatus = get(
        response,
        'data.response.other_params.current_status',
        '',
      ).toUpperCase();
      router(dispatch, uid, false, response);
      dispatch({ type: SET_ACTION_MESSAGE });
      dispatch({ type: CLOSE_USPS_MODEL });
      dispatch({
        type: `GET_${currentStatus}_SUCCESS`,
        payload: get(response, 'data.response', null),
        params: {},
      });
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HealthCheck));
